import React, { useState } from 'react';
import API_BASE_URL from '../config/api';
import { useAuth } from '../context/AuthContext';

const UpgradeModal = ({ onClose }) => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(null); // 'monthly' | 'annual' | null

  const startCheckout = async (plan) => {
    if (!user) return;
    setLoading(plan);
    try {
      const res = await fetch(`${API_BASE_URL}/api/subscriptions/create-checkout-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId: user.sub, plan }),
      });
      const data = await res.json();
      if (data.success && data.url) {
        window.location.href = data.url;
      } else {
        console.error('Checkout error:', data.error);
        setLoading(null);
      }
    } catch (err) {
      console.error('Checkout request failed:', err);
      setLoading(null);
    }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button style={styles.closeBtn} onClick={onClose}>✕</button>

        <div style={styles.header}>
          <span style={styles.lockIcon}>🔒</span>
          <h2 style={styles.title}>Upgrade to unlock this feature</h2>
          <p style={styles.subtitle}>Get full access to Opportunities and Trades</p>
        </div>

        <ul style={styles.featureList}>
          <li style={styles.featureItem}>✓ Arbitrage opportunity scanner</li>
          <li style={styles.featureItem}>✓ Trade tracking &amp; management</li>
          <li style={styles.featureItem}>✓ Hedge calculator</li>
          <li style={styles.featureItem}>✓ P&amp;L and funding analytics</li>
          <li style={styles.featureItem}>✓ Future paid features included</li>
        </ul>

        <div style={styles.plans}>
          <div style={styles.planCard}>
            <div style={styles.planName}>Monthly</div>
            <div style={styles.planPrice}>$15<span style={styles.planPeriod}>/mo</span></div>
            <button
              style={{ ...styles.planBtn, opacity: loading === 'monthly' ? 0.6 : 1 }}
              disabled={!!loading}
              onClick={() => startCheckout('monthly')}
            >
              {loading === 'monthly' ? 'Redirecting…' : 'Subscribe Monthly'}
            </button>
          </div>

          <div style={{ ...styles.planCard, ...styles.planCardHighlight }}>
            <div style={styles.bestValue}>Best value</div>
            <div style={styles.planName}>Annual</div>
            <div style={styles.planPrice}>$150<span style={styles.planPeriod}>/yr</span></div>
            <div style={styles.planSaving}>Save $30 vs monthly</div>
            <button
              style={{ ...styles.planBtn, ...styles.planBtnHighlight, opacity: loading === 'annual' ? 0.6 : 1 }}
              disabled={!!loading}
              onClick={() => startCheckout('annual')}
            >
              {loading === 'annual' ? 'Redirecting…' : 'Subscribe Annual'}
            </button>
          </div>
        </div>

        <p style={{ marginTop: '16px', fontSize: '11px', color: '#484f58', textAlign: 'center', lineHeight: '1.6' }}>
          By subscribing you agree to our{' '}
          <a href="/terms" target="_blank" rel="noreferrer" style={{ color: '#8b949e' }}>Terms &amp; Conditions</a>
          {' '}and{' '}
          <a href="/privacy" target="_blank" rel="noreferrer" style={{ color: '#8b949e' }}>Privacy Policy</a>.
        </p>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed', inset: 0,
    background: 'rgba(0,0,0,0.7)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 9000,
  },
  modal: {
    background: '#1a1b23',
    border: '1px solid #2a2d3a',
    borderRadius: '12px',
    padding: '32px',
    width: '420px',
    maxWidth: '90vw',
    position: 'relative',
  },
  closeBtn: {
    position: 'absolute', top: '16px', right: '16px',
    background: 'none', border: 'none', color: '#8b949e',
    fontSize: '16px', cursor: 'pointer', lineHeight: 1,
  },
  header: { textAlign: 'center', marginBottom: '24px' },
  lockIcon: { fontSize: '32px', display: 'block', marginBottom: '8px' },
  title: { margin: '0 0 8px', fontSize: '18px', fontWeight: 600, color: '#ffffff' },
  subtitle: { margin: 0, fontSize: '13px', color: '#8b949e' },
  featureList: {
    listStyle: 'none', padding: 0, margin: '0 0 24px',
  },
  featureItem: {
    fontSize: '13px', color: '#3fb950', padding: '4px 0',
  },
  plans: { display: 'flex', gap: '12px' },
  planCard: {
    flex: 1, background: '#0a0b0f', border: '1px solid #2a2d3a',
    borderRadius: '8px', padding: '16px', textAlign: 'center', position: 'relative',
  },
  planCardHighlight: { border: '1px solid #58a6ff' },
  bestValue: {
    position: 'absolute', top: '-10px', left: '50%', transform: 'translateX(-50%)',
    background: '#58a6ff', color: '#0a0b0f', fontSize: '10px', fontWeight: 700,
    padding: '2px 8px', borderRadius: '10px', whiteSpace: 'nowrap',
  },
  planName: { fontSize: '13px', color: '#8b949e', marginBottom: '8px' },
  planPrice: { fontSize: '28px', fontWeight: 700, color: '#ffffff', marginBottom: '4px' },
  planPeriod: { fontSize: '14px', fontWeight: 400, color: '#8b949e' },
  planSaving: { fontSize: '11px', color: '#3fb950', marginBottom: '12px' },
  planBtn: {
    width: '100%', padding: '8px', marginTop: '12px',
    background: '#2a2d3a', border: '1px solid #3a3d4a',
    borderRadius: '6px', color: '#ffffff', fontSize: '12px',
    cursor: 'pointer', fontWeight: 500,
  },
  planBtnHighlight: {
    background: '#58a6ff', border: 'none', color: '#0a0b0f',
  },
};

export default UpgradeModal;
